import { User } from '@gbr-monorepo/interfaces';

export class LoadWorkersCouncilGroups {
    static readonly type = '[WorkersCouncilGroup] Load';
    constructor(public isAscendingOrder: boolean) {}
}
export class LazyLoadWorkersCouncilGroups {
    static readonly type = '[WorkersCouncilGroup] Lazy Load';
    constructor(public isAscendingOrder: boolean) {}
}
export class AddDelegate {
    static readonly type = '[WorkersCouncilGroup] Add Delegate';
    constructor(
        public groupId: string,
        public user: User
    ) {}
}

export class RemoveDelegate {
    static readonly type = '[WorkersCouncilGroup] Remove Delegate';
    constructor(
        public groupId: string,
        public gid: string
    ) {}
}

export class LoadDelegateUsers {
    static readonly type = '[WorkersCouncilGroup] Load Delegate Users';
    constructor(
        public readonly search: string,
        public readonly page: number
    ) {}
}
